var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { registerSystem, DEPTHS } from "../ComponentRegistry.js";
import { R as RandomSchema } from "../../Random-b6daba3a.js";
import { generate } from "../../utils/rand.js";
import "../types.js";
import { C as ComponentCategory } from "../../enums-86f58524.js";
import "../../decorators/type.js";
import "ajv";
import "../../utils/clone.js";
import "bitecs";
import "../../utils/typehelpers.js";
import "../../global-33d5eebf.js";
import "../../utils/byteArray.js";
import "../../utils/vector.js";
import "seedrandom";
const stringToNumber = (str) => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = (hash << 5) - hash + str.charCodeAt(i);
    hash |= 0;
  }
  return hash;
};
class RandomSystem {
  constructor() {
    __publicField(this, "type", "Random");
    __publicField(this, "category", ComponentCategory.CORE);
    __publicField(this, "schema", RandomSchema);
    __publicField(this, "depth", DEPTHS.CORE);
    __publicField(this, "run", (entity, gameModel) => {
      const r = gameModel.getTypedUnsafe(entity, RandomSchema);
      r.random = generate(gameModel.frame + r.seedNumber);
    });
  }
  init(entity, gameModel) {
    const r = gameModel.getTypedUnsafe(entity, RandomSchema);
    if (!r.seedNumber) {
      if (r.seed) {
        r.seedNumber = stringToNumber(r.seed);
      } else {
        r.seedNumber = 0;
      }
    }
    r.random = generate(gameModel.frame + r.seedNumber);
  }
}
registerSystem(RandomSystem);
//# sourceMappingURL=Random.js.map
